import { gql } from '@apollo/client';
import type {
    InhubSortingDimension,
    InhubSortingMetric
} from '../types';

export const GET_INHUB_SORTING_GROUP_COMPARISON = gql`
  query GetInhubSortingGroupComparison($filter: InhubSortingMetricDimensionInput!) {
    getInhubSortingGroupComparison(filter: $filter) {
      metric
      dimension
      bars {
        name
        value
      }
    }
  }
`;

export interface InhubSortingGroupBarResp {
    name: string;
    value: number;
}

export interface GetInhubSortingGroupComparisonResponse {
    getInhubSortingGroupComparison: {
        metric: InhubSortingMetric;
        dimension: InhubSortingDimension;
        bars: InhubSortingGroupBarResp[];
    };
}
